module.exports = require('i18n-context')('ember_period_selector', {
    en_US: require('../locales/en_US'),
    da_DK: require('../locales/da_DK'),
    fr_FR: require('../locales/fr_FR'),
    de_DE: require('../locales/de_DE'),
    nl_NL: require('../locales/nl_NL'),
});
